import React from 'react'
import { useState } from 'react'
import { Container, Table, Button, Form, ButtonGroup, FormCheck } from 'react-bootstrap'
import AddChildModal from './AddChildModal'

function SubTable({ SubTableProps }) {
    const [modalDataIndex, setModalDataIndex] = useState(null);
    const [btnsClicked, setBtnsClicked] = useState({})
    const { locales, tableData, indexWalk, expandHandler, editHandler, editChangeHandler, deleteHandler, idWalk, theadLight, saveHandler, topTableData, setTableData, getEntryRecursive, type, checkHandler, isParentSelected } = SubTableProps

    const closeModalHandler = () => setModalDataIndex(null)

    const AddChildModalProps = { modalDataIndex, closeModalHandler, locales, topTableData, indexWalk, setTableData, getEntryRecursive, type }

    return (
        <>
            {modalDataIndex !== null && <AddChildModal AddChildModalProps={{ ...AddChildModalProps }} />}
            <Container fluid>
                <div className='table-responsive tablebg'>
                    <Table className='mb-0 align-middle'>
                        <thead className={theadLight ? theadLight : 'table-dark'}>
                            <tr>
                                <th>Select</th>
                                <th scope='col'>Expand</th>
                                <th scope='col'>#</th>
                                {locales.map(item => (<th scope='col' key={item.value}>{item.label}</th>))}
                                <th scope='col'>Action</th>
                            </tr>
                        </thead>
                        {tableData.length > 0 &&
                            <tbody>
                                {tableData.map((row, index) => {
                                    const updatedIndexWalk = [...indexWalk, index]
                                    const updatedIdWalk = [...idWalk, row._id]
                                    const checkDisabled = !!isParentSelected
                                    const deleteBtnHandler = async () => {
                                        if (btnsClicked[row._id]) return
                                        setBtnsClicked(prevBtnsClicked => ({ ...prevBtnsClicked, [row._id]: true }))
                                        await deleteHandler(updatedIndexWalk, updatedIdWalk)
                                        setBtnsClicked(prevBtnsClicked => ({ ...prevBtnsClicked, [row._id]: false }))
                                    }
                                    return (
                                        <React.Fragment key={row._id}>
                                            <tr>
                                                <td className='td--expand text-center'><FormCheck disabled={checkDisabled} checked={!!row.isSelected || checkDisabled} id={row._id} onChange={() => checkHandler(updatedIndexWalk, updatedIdWalk)} aria-label={row.data[0].name} /></td>
                                                <td className='td--expand text-center'>
                                                    <Button onClick={() => expandHandler(updatedIndexWalk)} variant={!row.hasChildren && 'danger'} disabled={!row.hasChildren} >{row.isExpanded ? "-" : "+"}</Button>
                                                    {/* <Button onClick={() => expandHandler(updatedIndexWalk)} className={`accordion accordion-button ${row.isExpanded ? '' : 'collapsed'} rounded`}
                                                        variant={!row.hasChildren && 'danger'} disabled={!row.hasChildren} /> */}
                                                </td>
                                                <th scope='row'>{row.id}</th>
                                                {row.data.map(item => (
                                                    <td key={item._id}>{row.editable ? <Form.Control type='text' defaultValue={item.name} onChange={(e) => editChangeHandler(updatedIndexWalk, e, item._id)} /> : item.name}</td>
                                                ))}
                                                <td>
                                                    {row.editable
                                                        ?
                                                        <ButtonGroup>
                                                            <Button key='Save' variant='success' onClick={() => saveHandler(updatedIndexWalk, updatedIdWalk)} disabled={!row.updatedVal}>Save</Button>
                                                            <Button key='Cancel' variant='danger' onClick={() => editHandler(updatedIndexWalk)}>Cancel</Button>
                                                        </ButtonGroup>
                                                        :
                                                        <ButtonGroup>
                                                            <Button key='Add' variant='success' onClick={() => setModalDataIndex(index)}>Add</Button>
                                                            <Button key='Edit' variant='warning' onClick={() => editHandler(updatedIndexWalk)}>Edit</Button>
                                                            <Button disabled={btnsClicked[row._id]} key='Delete' variant='danger' onClick={deleteBtnHandler}>Delete</Button>
                                                        </ButtonGroup>
                                                    }
                                                </td>
                                            </tr>
                                            {row.isExpanded && row.hasChildren &&
                                                <>
                                                    <tr>
                                                        <td colSpan={4 + locales.length}>
                                                            <Container>
                                                                <SubTable SubTableProps={{ ...SubTableProps, tableData: row.children, indexWalk: updatedIndexWalk, idWalk: updatedIdWalk, theadLight: 'table-light', isParentSelected: (row.isSelected || checkDisabled) }} />
                                                            </Container>
                                                        </td>
                                                    </tr>
                                                </>}
                                        </React.Fragment>
                                    )
                                })}
                            </tbody>}
                    </Table>
                </div>
            </Container>
        </>
    )
}

export default SubTable